import { useEffect, useState, useMemo } from 'react';
import { setIsMobile, setIsTablet } from '../../actions/configActions';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';

export default () => {
    const [width, setWidth] = useState<number>(window.innerWidth);
    const dispatch = useDispatch();

    const debouncedHandleResize = useMemo(() => debounce(() => setWidth(window.innerWidth), 200), []);

    useEffect(() => {
        const handleOrientationChange = () => {
            // Flush any pending debounced calls and update immediately
            debouncedHandleResize.cancel();
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', debouncedHandleResize);
        window.addEventListener('orientationchange', handleOrientationChange);
        
        return () => {
            window.removeEventListener('resize', debouncedHandleResize);
            window.removeEventListener('orientationchange', handleOrientationChange);
            debouncedHandleResize.cancel();
        };
    }, [debouncedHandleResize]);

    useEffect(() => {
        // Mobile: width < 768px
        // Tablet: width >= 768px && width < 1280px (covers all iPad landscape sizes up to 11")
        // Desktop: width >= 1280px
        const isMobile = width < 768;
        const isTablet = width >= 768 && width < 1280;
        
        dispatch(setIsMobile(isMobile));
        dispatch(setIsTablet(isTablet));
    }, [width, dispatch]);

    return null;
};
